export class StringUtil {

    /**
     * Remove accents from characters (NFD)
     * Lower case
     * @param str 
     * @returns 
     */
    static normalizeStringLowerCase(str: string): string {
        // remove accents
        const normalizedString: string = str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
        return normalizedString
    }

}